import { useEffect } from 'react';
import {
  DateTimeInput,
  Edit,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRecordContext,
  useRedirect,
} from 'react-admin';

export const NotificationEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const record = useRecordContext();

  const transform = (data: any) => {
    const transformedData = { ...data };

    if (transformedData.scheduled_at) {
      const date = new Date(transformedData.scheduled_at);
      transformedData.scheduled_at = date.toISOString();
    }

    return transformedData;
  };

  useEffect(() => {
    if (record && record.status !== 0) {
      notify('Only pending notifications can be edited', { type: 'warning' });
      redirect('show', 'notifications', record.id);
    }
  }, [record, notify, redirect]);

  return (
    <Edit transform={transform}>
      <SimpleForm>
        <TextInput source="title" validate={[required()]} fullWidth />
        <TextInput source="text" validate={[required()]} multiline fullWidth />
        <DateTimeInput source="scheduled_at" />
        <SelectInput
          source="status"
          validate={[required()]}
          disabled
          choices={[
            { id: 0, name: 'Pending' },
            { id: 1, name: 'Processing' },
            { id: 2, name: 'Sent' },
            { id: 3, name: 'Failed' },
          ]}
        />
      </SimpleForm>
    </Edit>
  );
};

export default NotificationEdit;
